import AvisOutdoorLogo from './logo'
import {avisOutdoorStylesFR} from './styles'

const baseConfig = {
  domainName: 'avisoutdoor' as const,
  domainType: 'eu' as const,
  siteName: 'Avis Outdoor',
  logo: <AvisOutdoorLogo className="size-8 shrink-0 tablet:size-6" locale="fr" />,
  favicon: '/favicons/avisoutdoor.png',
}

const localeConfigs = {
  fr: {
    measurementId: 'G-576BNE9TC7',
    camelCaseUrl: 'AvisOutdoor.fr',
    title: (category: string, _count: string) => `Avis ${category} : Comparatifs, Tests et Sélections Fiables`,
    description: (_category?: string, _count?: string) =>
      `Découvrez nos recommandations pour vos activités outdoor avec des avis précis, des comparatifs détaillés et des tests sur l’équipement essentiel.`,
    styles: avisOutdoorStylesFR,
  },
}

export const createConfig = (locale: string = 'fr') => {
  const localeConfig = localeConfigs[locale as keyof typeof localeConfigs] || localeConfigs.fr
  return {
    ...baseConfig,
    ...localeConfig,
  }
}
